import React from 'react';
import Downshift from 'downshift';
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
  Paper,
} from '@material-ui/core';

import CityList from './CityList';
import { isMobile } from '../../../lib/getDeviceSize';

import styles from '../../../styles/sass/components/LocationForm.module.scss';

interface Props {
  cities: any[];
  disabled?: boolean;
  hideCityField?: boolean;
  locations: any[];
  selectedCity: string | undefined;
  selectedLocation: string | undefined;
  setCity: Function;
  setLocation: Function;
  wrapperClasses?: any;
}

interface State {
  disableTextField: boolean;
  filteredCities: any[];
  searchText: string | undefined;
  showDropdown: boolean;
}

export class LocationDropDown extends React.Component<Props, State> {
  clearSelection: any;
  selectedItem: any;
  state = {
    disableTextField: true,
    filteredCities: [],
    showDropdown: false,
    searchText: undefined,
  };

  componentDidMount() {
    if (this.props.selectedLocation) {
      this.setLocation(this.props.selectedLocation);
    }
  }

  setLocation = (result: any) => {
    this.setState(
      {
        disableTextField: false,
        searchText: undefined,
      },
      () => {
        this.props.setLocation(result);
      },
    );
  };

  _onChange = (event: any) => {
    const text = event.target.value;
    this.setState(
      {
        searchText: text,
      },
      () => {
        if (text && text.length > 0) {
          const filteredCities = this.props.cities.filter((city: string) => {
            if (city.toLowerCase().includes(text.toLowerCase())) {
              return city;
            }
          });
          this.setState({
            filteredCities,
            showDropdown: true,
          });
        } else {
          this.setState(
            {
              filteredCities: [],
              showDropdown: false,
            },
            () => {
              if (this.clearSelection) {
                this.clearSelection();
              }
              this.props.setCity(undefined);
            },
          );
        }
      },
    );
  };

  onCitySelect = (city: string) => {
    this.setState(
      {
        searchText: city,
        showDropdown: false,
      },
      () => {
        this.props.setCity(city);
      },
    );
  };

  onInputBlur = () => {
    this.setState({
      showDropdown: false,
    });
  };

  render() {
    const {
      disableTextField,
      filteredCities,
      searchText,
      showDropdown,
    } = this.state;
    const {
      disabled,
      hideCityField,
      locations,
      selectedLocation,
      selectedCity,
      wrapperClasses,
    } = this.props;
    return (
      <div
        className={
          wrapperClasses
            ? wrapperClasses
            : styles.compsAddressSearchFieldWrapper
        }
      >
        <FormControl
          className={`${styles.formControl} ${
            wrapperClasses ? '' : styles.padding
          }`}
        >
          <InputLabel>Location</InputLabel>
          <Select
            className={`${styles.compsAddressSearchField} ${
              wrapperClasses ? '' : styles.padding
            }`}
            disabled={disabled}
            MenuProps={{
              anchorOrigin: {
                horizontal: 'left',
                vertical: 'bottom',
              },
              getContentAnchorEl: null,
            }}
            onChange={(event: any) => this.setLocation(event.target.value)}
            placeholder="Location"
            value={selectedLocation}
          >
            {Object.keys(locations).map((location: any) => {
              return (
                <MenuItem key={location} value={location}>
                  {locations[location]}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {!hideCityField && (
          <Downshift
            onSelect={selection => {
              this.onCitySelect(selection);
            }}
          >
            {({ getItemProps }) => {
              return (
                <div
                  className={`${styles.formControl} ${
                    wrapperClasses ? '' : styles.padding
                  }`}
                >
                  <TextField
                    key={selectedLocation}
                    disabled={disableTextField}
                    defaultValue={this.props.selectedCity}
                    onChange={this._onChange}
                    value={searchText}
                    label="City/Town"
                    onBlur={this.onInputBlur}
                    style={{ fontSize: 16, width: '100%' }}
                  />
                  {showDropdown && (
                    <Paper
                      style={{
                        position: 'absolute',
                        width: isMobile()
                          ? wrapperClasses
                            ? 300
                            : 200
                          : wrapperClasses
                          ? 400
                          : 200,
                        zIndex: 1,
                        marginTop: wrapperClasses ? 50 : 50,
                      }}
                    >
                      <CityList
                        filteredCities={filteredCities}
                        getItemProps={getItemProps}
                      />
                    </Paper>
                  )}
                </div>
              );
            }}
          </Downshift>
        )}
        {this.props.children && (
          <div
            className={`${styles.formControl} ${
              wrapperClasses ? '' : styles.padding
            }`}
          >
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

export default LocationDropDown;
